import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import Img from 'gatsby-image'
import Header from '../components/Header'
import Fullscreen from 'react-full-screen'
import Draggable from 'react-draggable'
import '../styles/css/style.min.css'


const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="Peterson Group"
      meta={[
        { name: 'description', content: 'Sample' },
        { name: 'keywords', content: 'sample, something' },
      ]}
    />

    <div>
      {children()}
    </div>
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js